$(document).ready(function () {
    $('#passwordResetForm').on('submit', function (e) {
        e.preventDefault();
        var oldHtml = $('#btnPasswordResetFormSubmit').html();
        $('#btnPasswordResetFormSubmit').attr('disabled', true);
        $('#btnPasswordResetFormSubmit').html('Aguarde...');

        let that = this;

        $.get('/logout').then(function () {
            $.ajax({
                'url': 'password/email',
                'method': 'post',
                'data': $(that).serialize()
            }).then(function (res) {
                alert(res);
                $('#btnPasswordResetFormSubmit').removeAttr('disabled');
                $('#modal-esqueci-minha-senha').modal('hide');
                $('#btnPasswordResetFormSubmit').html(oldHtml);
            }).catch(function (err) {
                if (err.status === 422) {
                    var erros = '';
                    if (err.responseJSON) {

                        angular.forEach(err.responseJSON.errors, function (value) {
                            for (var j = 0; j < value.length; j++) {
                                erros += value[j] + '<br>';
                            }
                        });
                    } else {
                        erros = err.responseText;
                    }
                    $.gritter.add({
                        title: 'Erro ao processar requisição',
                        text: erros,
                        time: 10000,
                        class_name: 'erro'
                    });
                } else {
                    alert('Houve um erro ao processar a requisição. Por favor, tente novamente mais tarde.');
                }
                $('#btnPasswordResetFormSubmit').removeAttr('disabled');
                $('#btnPasswordResetFormSubmit').html(oldHtml);
            });
        })


    });
})